import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        this.id = this.getData('id') ? this.getData('id') : false
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Callbacks
    ///////////////
    onScrollProgress(progress) {
        if (this.id) {
            this.call('onSectionProgress', { progress, id: this.id }, 'Sidebar')
        } else {
            this.call('onSidebarInview', progress, 'Sidebar')
        }
    }
}
